'use client'

import { compactClassName } from '@/components/homepage-october/compact'
import * as React from 'react'
import { Columns2 } from '@/components/homepage-october/lucide'

import { ChipLinks, Eyebrow, Section } from '../blocks/layout'
import { ProductRail } from '../blocks/Rail'
import type { Model } from '../types'

/**
 * V23b, new in v3 (owner 10/15/2026: "add in a product carousel of a type we have not done yet"): side-by-side
 * refrigerators, a type the page showed only here and there, as a row of its own. Twelve from the catalog
 * (tools/extract_v3_model.py, research/db-2026-10-15/side-by-side-rail.json), highest shopper rating first, on the
 * shadcn Carousel that steps by itself and pauses on hover and focus, with the page's own side-by-side links under it.
 */
export function SideBySide({ model }: { model: Model }) {
  const m = model.sbs
  return (
    <Section aria={m.aria} v2={m.v2} tone="white">
      <div className={compactClassName("rounded-3xl bg-[#f3f8ff] p-4 ring-1 ring-[#0469f0]/10 sm:p-5 md:p-6")}>
        <ProductRail
          products={m.products}
          title={m.head.title}
          sub={m.head.sub}
          viewAll={m.head.viewAll}
          level={2}
          autoplay={5600}
          kicker={
            <div className={compactClassName("mb-3 flex items-center gap-2.5")}>
              <span aria-hidden="true" className={compactClassName("inline-flex size-10 items-center justify-center rounded-xl bg-white text-[#0454c0] shadow-xs ring-1 ring-black/5")}>
                <Columns2 className="size-5" />
              </span>
              <Eyebrow tone="sky">{m.head.eyebrow}</Eyebrow>
            </div>
          }
        />
        <ChipLinks links={m.chips} className="mt-5" />
      </div>
    </Section>
  )
}
